module.exports = __webpack_public_path__ + "static/06-52a4ce451af5cfc474854399881a270a.jpg";